export const USER_GET = 'USER_GET'
export const USER_LIST_GET = 'USER_LIST_GET'
export const USER_CONTEXT_LOADED = 'USER_CONTEXT_LOADED'
export const USER_DIALOG_SIZE_CHANGED = 'USER_DIALOG_SIZE_CHANGED'
export const USER_DIALOG_SETTINGS_UPDATE = 'USER_DIALOG_SETTINGS_UPDATE'
